import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

import BottomSheet from '@perpay-web/components/base/BottomSheet/BottomSheet';
import CreatePasswordStep from '@perpay-web/components/composite/UserVerificationModal/CreatePasswordStep';
import VerifyPhoneNumberStep from '@perpay-web/components/composite/UserVerificationModal/VerifyPhoneNumberStep';
import { getClassName } from '@perpay-web/utils/domUtils';

import styles from './UserVerificationModal.scss';

const UserVerificationModal = ({
    className,
    onClose,
    signupRequirements,
    passwordLoading,
    passwordErrors,
    onPasswordViewed,
    onSubmitPassword,
    onVerifyPhoneNumber,
    mobilePhone,
    onResend,
    phoneLoading,
    phoneErrors,
    onLoadPhoneVerificationView,
    onHelpButtonClick,
    onMount,
    isUserInfoLoading,
    launchSupportTool,
    openPhoneNumberModal,
}) => {
    const [hasMounted, setHasMounted] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        onMount();
        setHasMounted(true);
    }, [onMount]);

    // Send text to user when loading modal for the first time.
    useEffect(() => {
        if (
            signupRequirements.includes('password_set') ||
            !hasMounted ||
            isUserInfoLoading
        ) {
            return;
        }

        if (!mobilePhone) {
            openPhoneNumberModal();
        } else {
            onResend();
        }
    }, [
        mobilePhone,
        navigate,
        onResend,
        isUserInfoLoading,
        signupRequirements,
        hasMounted,
        openPhoneNumberModal,
    ]);

    return (
        <BottomSheet
            onClose={onClose}
            className={getClassName(styles['modal-container'], className)}
            contentClassName={styles['bottom-sheet-content']}
            showClose={false}
            allowDismissal={false}
        >
            {signupRequirements.includes('password_set') ? (
                <CreatePasswordStep
                    onSubmitPassword={onSubmitPassword}
                    onSubmitPasswordErrors={passwordErrors}
                    onLoadPageView={onPasswordViewed}
                    loading={passwordLoading}
                    onHelpButtonClick={launchSupportTool}
                />
            ) : (
                <VerifyPhoneNumberStep
                    verifyPhoneNumber={onVerifyPhoneNumber}
                    mobilePhone={mobilePhone}
                    onResend={onResend}
                    loading={phoneLoading}
                    errors={phoneErrors}
                    onHelpButtonClick={onHelpButtonClick}
                    onLoadPageView={onLoadPhoneVerificationView}
                />
            )}
        </BottomSheet>
    );
};

export default UserVerificationModal;
